import { useEffect, useState } from 'react';
import checkApiStatus from '../component/SubscripStatus';
import { userInfoAtom } from '../data/atoms/utilsAtoms';
import { useAtom } from 'jotai';
import { useLocation } from 'react-router-dom';

export const useVerifySubscription = (skip = false) => {
	const [userData, setUserData] = useAtom(userInfoAtom);
	const location = useLocation();
	const [apiStatus, setApiStatus] = useState(skip ? true : null);

	useEffect(() => {
		if (skip) {
			setApiStatus(true);
			return;
		}

		(async () => {
			try {
				// Check API status with the token and update userData if needed.
				const status = await checkApiStatus(userData.token, setUserData);
				setApiStatus(status);
			} catch (error) {
				console.error('Error checking API status:', error);
				setApiStatus(false);
			}
		})();
	}, [location.pathname, userData.token, userData.subscriptionId, setUserData, skip]);

	return apiStatus;
};
